export default {
  text: "Don't have an account?",
  link: 'Create new account',
};
